import { useNavigate } from "react-router-dom";

import CommonLayout from "../CommonLayout";

import Footer from "../../../components/Footer";
import Buttons from "./components/Buttons";
import Filters from "./components/Filters";
import Table from "./components/Table";

import { ROUTES } from "../../../config/routes";
import { SETTLEMENT_TABLE_COLUMNS } from "../../../config/tables";
import { useFetchSettlements } from "./hooks/useFetchSettlements";
import { FiltersType } from "./types/filters.type";
import { useTableFiltersCursor } from "../../../hooks/useTableFiltersCursor";

const TABLE_KEY = "settlements";

const SettlementsContainer = () => {
  const navigate = useNavigate();

  const { queryFilters, setQueryFilters, cursor, setCursor } =
    useTableFiltersCursor<FiltersType>(TABLE_KEY);
  const { settlements, nextCursor, isLoading } = useFetchSettlements(
    queryFilters,
    cursor
  );

  const goToDetail = (details: {
    type: "invoices" | "adjustments";
    date: string;
    cycle: string;
  }) => {
    const path = ROUTES.DASHBOARD.SETTLEMENT_DETAIL.replace(
      ":settlementId",
      `${details.date}_${details.cycle}`
    );
    navigate(`${path}?detail=${details.type}`);
  };

  const filters = (
    <Filters queryFilters={queryFilters} setQueryFilters={setQueryFilters} />
  );

  const buttons = <Buttons />;

  const table = (
    <Table
      settlements={settlements}
      isLoading={isLoading}
      setShowDetails={goToDetail}
    />
  );

  const footer = (
    <Footer
      tableProps={{
        fileName: "conciliaciones",
        items: settlements,
        columns: SETTLEMENT_TABLE_COLUMNS,
        pagination: { tableKey: TABLE_KEY, nextCursor, setCursor, cursor },
      }}
    />
  );

  return CommonLayout({
    title: "Conciliación",
    subtitle:
      "Concilia tus transacciones en Palomma contra tu extracto bancario",
    filters,
    buttons,
    table,
    footer,
  });
};

export default SettlementsContainer;
